export default {
  mutations: {
    SET_PAYOUT_PIX_TYPES_LIST: 'SET_PAYOUT_PIX_TYPES_LIST',
  },
  getters: {
    GET_PAYOUT_PIX_TYPES_LIST: 'GET_PAYOUT_PIX_TYPES_LIST',
  },
  actions: {
    PAYOUT_PIX_TYPES_LIST: 'PAYOUT_PIX_TYPES_LIST',
  },
};
